import React from 'react';
import { Spinner } from '@chakra-ui/react';

const LoadingScreen = () => (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', width: '100%', alignItems: 'center' }}>
        <Spinner size="xl" />
    </div>
)

export default LoadingScreen;